var mentions_default = {
  "mentionPalette": "N3GOK",
  "mention": "_52wZK",
  "mentionViewer": "g7Jok",
  "mentionSuggestionsEntry": "vslx3",
  "mentionSuggestionsEntryFocused": "bRkOr",
  "mentionSuggestionsEntryText": "dxcme",
  "mentionSuggestionsEntryAvatar": "Irach",
  "mentionSuggestions": "j-ErT",
  "cursorDefault": "w0oK6",
  "cursorPointer": "v21L7"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
